import ReactMarkdown from "react-markdown";
import { useMemo } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { exportBrandedReport } from "@/lib/reportPdf";
import { localizeReport } from "@/lib/reportLanguage";
import { useAuth } from "@/lib/AuthContext";

const markdownComponents = {
  a: ({ children, ...props }) => <a {...props} rel="noopener noreferrer" data-testid={`report-link-${encodeURIComponent(props.href || "")}`}>{children}</a>,
};

export const AnalysisResults = ({ report, title, filename, onError, testId, allowExport = true,
                                  photosBefore = [], photosAfter = [], subtitle = "" }) => {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const [exporting, setExporting] = useState(false);
  const localized = useMemo(() => localizeReport(report, i18n.language), [report, i18n.language]);
  const exportReport = async () => {
    setExporting(true);
    try {
      await exportBrandedReport({
        title, subtitle, userName: user?.full_name, text: localized, filename,
        photosBefore, photosAfter,
        labels: {
          tagline: t("pdf.tagline"),
          before: t("photoAnalysis.photosBefore"),
          after: t("photoAnalysis.photosAfter"),
          coverDisclaimer: t("pdf.coverDisclaimer"),
        },
      });
    } catch (error) { onError(error.message); } finally { setExporting(false); }
  };
  return <>
    <div className="bg-card border border-border rounded-xl p-5" data-testid={`${testId}-report`}>
      <div className="prose prose-invert prose-sm max-w-none break-words [overflow-wrap:anywhere] prose-headings:text-primary prose-strong:text-foreground prose-p:text-foreground/90">
        <ReactMarkdown components={markdownComponents}>{localized}</ReactMarkdown>
      </div>
    </div>
    {allowExport && <Button onClick={exportReport} disabled={exporting} data-testid={`${testId}-export-pdf`} variant="outline" className="w-full text-primary h-12">
      {exporting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <FileDown className="w-4 h-4 mr-2" />}{t("common.downloadReportPdf")}
    </Button>}
  </>;
};
